import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { SHA256nymudvmltc47 as SHA256 } from '../../../../hash-library-sha2/org/kotlincrypto/hash/sha2/SHA256.mjs';
import { hash1fp34sezu95cc as hash } from './Bit32Digest.ext.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { Companion_getInstance3n9as6ds1py67 as Companion_getInstance } from '../../../../lightning-server-shared/com/lightningkite/UUID.js.mjs';
import { numberRangeToNumber25vse2rgp6rs8 as numberRangeToNumber } from '../../../../kotlin-kotlin-stdlib/kotlin/js/rangeTo.mjs';
import { sliceArray2hu2ljigibgmi as sliceArray } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/_Arrays.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function combineWith(_this__u8e3s4, other, seed) {
  seed = seed === VOID ? null : seed;
  var digest = SHA256().j53();
  if (seed == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    hash(digest, seed);
  }
  hash(digest, _this__u8e3s4);
  hash(digest, other);
  var hash_0 = digest.g51();
  return Companion_getInstance().d4z(sliceArray(hash_0, numberRangeToNumber(0, 15)));
}
//region block: exports
export {
  combineWith as combineWith38f9w17ugug7w,
};
//endregion

//# sourceMappingURL=UUID.ext.mjs.map
